import { IsNotEmpty, IsString, IsEnum, IsOptional, Min, Max, IsBoolean, IsNumber, IsDate } from 'class-validator';
import { Type } from 'class-transformer';
import { CouponType } from '@/modules/coupon/schemas/coupon.schema';

export class CreateCouponDto {
  @IsNotEmpty()
  @IsString()
  code: string;

  @IsOptional()
  @IsString()
  description?: string;

  @IsNotEmpty()
  @IsEnum(CouponType)
  type: CouponType;

  @IsNotEmpty()
  @IsNumber()
  @Min(0)
  value: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  minimumOrderAmount?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  maximumDiscountAmount?: number;

  @IsOptional()
  @Type(() => Date)
  @IsDate()
  startDate?: Date;

  @IsNotEmpty()
  @Type(() => Date)
  @IsDate()
  expiryDate: Date;

  @IsNotEmpty()
  @IsNumber()
  @Min(1)
  usageLimit: number;

  @IsOptional()
  @IsBoolean()
  isShippingDiscount?: boolean;

  @IsOptional()
  @IsBoolean()
  isActive?: boolean;
}
